export interface OrganizationName {
  value: string;
}

export interface OrganizationAddress {
  value: string;
}

export interface OrganizationLocation {
  value: string;
}

export class Organization {
  constructor(
    private readonly _name: OrganizationName,
    private readonly _address: OrganizationAddress,
    private readonly _location: OrganizationLocation
  ) {}

  get name(): OrganizationName {
    return this._name;
  }

  get address(): OrganizationAddress {
    return this._address;
  }

  get location(): OrganizationLocation {
    return this._location;
  }

  getFullAddress(): string {
    return `${this._address.value}, ${this._location.value}`;
  }
} 